import { render, staticRenderFns } from "./AdvisorFeeInput.vue?vue&type=template&id=76a2ae5e&"
import script from "./AdvisorFeeInput.vue?vue&type=script&lang=js&"
export * from "./AdvisorFeeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports